import React, { useEffect, useRef, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import recordprint from '../../assets/Record/recordprint.jpg';
import { Button } from "@material-tailwind/react";
import { QRCodeCanvas } from "qrcode.react"; // 추가 import



// 백엔드 응답 데이터 타입 (모든 필드는 string)
type RecordData = {
  Competition: string;
  Bib: string;
  Name: string;
  Division: string;
  Time: string;
  Sex: string;
  Pace: string;
  Speed: string;
  A_rank: string;
  G_rank: string;
  O_rank: string;
  Net_start: string;
  Net_finish: string;
  Sa: string;
  Ws : string;
  // CP 관련 동적 컬럼: CP_01 ~ CP_12 (옵션)
  CP_01_NAME?: string;
  CP_01_TOD?: string;
  CP_01_TIME?: string;
  CP_02_NAME?: string;
  CP_02_TOD?: string;
  CP_02_TIME?: string;
  CP_03_NAME?: string;
  CP_03_TOD?: string;
  CP_03_TIME?: string;
  CP_04_NAME?: string;
  CP_04_TOD?: string;
  CP_04_TIME?: string;
  CP_05_NAME?: string;
  CP_05_TOD?: string;
  CP_05_TIME?: string;
  CP_06_NAME?: string;
  CP_06_TOD?: string;
  CP_06_TIME?: string;
  CP_07_NAME?: string;
  CP_07_TOD?: string;
  CP_07_TIME?: string;
  CP_08_NAME?: string;
  CP_08_TOD?: string;
  CP_08_TIME?: string;
  CP_09_NAME?: string;
  CP_09_TOD?: string;
  CP_09_TIME?: string;
  CP_10_NAME?: string;
  CP_10_TOD?: string;
  CP_10_TIME?: string;
  CP_11_NAME?: string;
  CP_11_TOD?: string;
  CP_11_TIME?: string;
  CP_12_NAME?: string;
  CP_12_TOD?: string;
  CP_12_TIME?: string;

  KOM_NAME?: string;
  KOM_TIME?: string;
  DOWN_SPEED_NAME?: string;
  DOWN_SPEED_TIME?: string;
};

const RecordInfo = () => {
  const { compTitle, bibNum } = useParams<{ compTitle?: string; bibNum?: string }>();
  const location = useLocation();
  const locationState = (location.state as { data?: RecordData[]; compCode?: number }) || {};
  const recordArray: RecordData[] = locationState.data || [];
  const record = recordArray.length > 0 ? recordArray[0] : null;
  
  const [compCode, setCompCode] = useState<number | null>(null);
  useEffect(() => {
    if (locationState.compCode) {
      setCompCode(locationState.compCode);
    }
  }, [locationState.compCode]);
  
  // 기존 상태들...
  const [userName, setUserName] = useState('이름 없음');
  const [userBib, setUserBib] = useState('-');
  const [gender, setGender] = useState('M');
  const [compTitleState, setCompTitleState] = useState('마라톤 대회');
  const [compDivLs, setCompDivLs] = useState('Full');
  const [compRecord, setCompRecord] = useState('기록이 없습니다.');
  const [startRecord, setStartRecord] = useState('00:00:00');
  const [arrivalRecord, setArrivalRecord] = useState('00:00:00');
  const [totalRank, setTotalRank] = useState('-');
  const [genderRank, setGenderRank] = useState('-');
  const [teamRank, setTeamRank] = useState('-');
  const [Pace, setPace] = useState('-');
  const [Speed, setSpeed] = useState('-');
  const [runType, setRunType] = useState('-');

  const navigate = useNavigate();
  const [qrValue, setQrValue] = useState("");

  // record 상태 업데이트
  useEffect(() => {
    if (record) {
      setUserName(record.Name);
      setUserBib(record.Bib);
      setCompDivLs(record.Division);
      setCompRecord(record.Time);
      setPace(record.Pace);
      setSpeed(record.Speed);
      setRunType(convertSa(record.Sa, record.Ws));
      setGender(record.Sex);
      setStartRecord(record.Net_start);
      setArrivalRecord(record.Net_finish);
      setGenderRank(record.G_rank === "-1/-1" ? "" : record.G_rank);
      setTotalRank(record.O_rank === "-1/-1" ? "" : record.O_rank);
      setTeamRank(record.A_rank === "-1/-1" ? "" : record.A_rank);
      setCompTitleState(record.Competition);
      if (record.Division.toLowerCase() !== "5km") {
        const dataForQr = `이름: ${record.Name}, 종목: ${record.Division}, 기록: ${record.Time}`;
        setQrValue(dataForQr);
      }
    }
  }, [record]);

const convertSa = (sa: string, ws?: string): string => {
  const saNorm = (sa ?? '').trim();
  const wsNorm = (ws ?? '').trim().toUpperCase();

  // ✅ 조건: sa가 '0' 또는 '정상'이고, ws가 'DSQ'일 때만 DSQ로 표시
  if ((saNorm === '0' || saNorm === '정상') && wsNorm === 'DSQ') {
    return 'DSQ';
  }

  // ✅ 나머지는 Sa 값 그대로 반환
  return saNorm;
    // // 나머지는 기존 Sa 코드 그대로 표시
  // switch (saNorm) {
  //   case '0': return '정상';
  //   case '1': return '불참';
  //   case '2': return 'DSQ';
  //   case '3': return 'DNF';
  //   case '4': return 'DNS';
  //   case '5': return '불참';
  //   default:  return saNorm;
  // }
};



// const renderCPRows = () => {
//   if (!record) return null;

//   /* === 0. 헬퍼 === */
//   const pushIfValid = (
//     rows: any[],
//     key: string,
//     div: string,
//     tod: string,
//     time: string
//   ) => {
//     // tod 가 없을 수도 있는 special 행 처리
//     if (time !== '-' && time.length > 1) {
//       rows.push({ key, div, tod: tod ?? '', time });
//     }
//   };

//   /* === 1. 특수(KOM, Down_speed) 먼저 넣기 === */
//   const rows: { key: string; div: string; tod: string; time: string }[] = [];

//   // 레코드 키는 모두 대문자로 넘어오므로 대문자 사용
//   const komDiv  = (record as any)['KOM_NAME']         ?? '-';
//   const komTime = (record as any)['KOM_TIME']         ?? '-';
//   const dwnDiv  = (record as any)['DOWN_SPEED_NAME']  ?? '-';
//   const dwnTime = (record as any)['DOWN_SPEED_TIME']  ?? '-';

//   pushIfValid(rows, 'KOM',        komDiv,  '', komTime);
//   pushIfValid(rows, 'DOWN_SPEED', dwnDiv,  '', dwnTime);

//   /* === 2. CP_xx 동적 행 === */
//   const cpNameKeys = Object.keys(record)
//     .filter(k => /^CP_\d+_NAME$/i.test(k))
//     .sort((a, b) => {
//       const nA = parseInt(a.match(/^CP_(\d+)_NAME$/i)![1], 10);
//       const nB = parseInt(b.match(/^CP_(\d+)_NAME$/i)![1], 10);
//       return nA - nB;
//     })
//     .filter(nameKey => {
//       const p   = nameKey.replace(/_NAME$/i, '');
//       const tod = (record as any)[`${p}_TOD`]  ?? '-';
//       const tim = (record as any)[`${p}_TIME`] ?? '-';
//       return tod !== '-' && tim !== '-';
//     });

//   cpNameKeys.forEach(nameKey => {
//     const p   = nameKey.replace(/_NAME$/i, '');
//     const div = (record as any)[nameKey]        ?? '';
//     const tod = (record as any)[`${p}_TOD`]     ?? '';
//     const tim = (record as any)[`${p}_TIME`]    ?? '';
//     rows.push({ key: nameKey, div, tod, time: tim });
//   });

//   /* === 3. 렌더 === */
//   const baseTop = 71;      // 첫 줄 y%
//   const gap     = 3.4;     // 행 간격 y%

//   return rows.map((row, idx) => {
//     const top = baseTop + idx * gap;
//     return (
//       <React.Fragment key={row.key}>
//         {/* 구간·KOM·Down_speed 이름 */}
//         <div style={{
//           color:'#FFF102', position:'absolute',
//           top:`${top}%`, left:'24%', transform:'translate(-50%,-50%)',
//           fontSize:'20px', fontWeight:'bold', whiteSpace:'nowrap'
//         }}>{row.div}</div>

//         {/* TOD (KOM/Down_speed는 공백) */}
//         <div style={{
//           color:'#FFF102', position:'absolute',
//           top:`${top}%`, left:'50%', transform:'translate(-50%,-50%)',
//           fontSize:'20px', fontWeight:'bold', whiteSpace:'nowrap'
//         }}>{row.tod}</div>

//         {/* TIME */}
//         <div style={{
//           color:'#FFF102', position:'absolute',
//           top:`${top}%`, left:'77%', transform:'translate(-50%,-50%)',
//           fontSize:'20px', fontWeight:'bold', whiteSpace:'nowrap'
//         }}>{row.time}</div>
//       </React.Fragment>
//     );
//   });
// };
const renderCPRows = () => {
  if (!record) return null;

  const pushIfValid = (rows: any[], key: string, div: string, tod: string, time: string) => {
    if (time !== '-' && time && time.length > 1) {
      rows.push({ key, div, tod: tod ?? '', time });
    }
  };

  const rows: { key: string; div: string; tod: string; time: string }[] = [];

  /* === 1. 특수구간(Triathlon 계열) 추가 === */
  const triList = [
    { timeKey: 'RUN_05KM',     nameKey: 'RUN_05KM_NAME' },
    { timeKey: 'T1',           nameKey: 'T1_NAME' },
    { timeKey: 'BIKE_40KM',    nameKey: 'BIKE_40KM_NAME' },
    { timeKey: 'T2',           nameKey: 'T2_NAME' },
    { timeKey: 'RUN_10KM',     nameKey: 'RUN_10KM_NAME' },
  ];

  triList.forEach(({ timeKey, nameKey }) => {
    const div  = (record as any)[nameKey] ?? '-';
    const time = (record as any)[timeKey] ?? '-';
    pushIfValid(rows, nameKey, div, '', time);
  });

  /* === 2. KOM / DownSpeed === */
  const komDiv  = (record as any)['KOM_NAME']        ?? '-';
  const komTime = (record as any)['KOM_TIME']        ?? '-';
  const dwnDiv  = (record as any)['DOWN_SPEED_NAME'] ?? '-';
  const dwnTime = (record as any)['DOWN_SPEED_TIME'] ?? '-';

  pushIfValid(rows, 'KOM',        komDiv,  '', komTime);
  pushIfValid(rows, 'DOWN_SPEED', dwnDiv,  '', dwnTime);

  /* === 3. CP_xx 동적 === */
  const cpNameKeys = Object.keys(record)
    .filter(k => /^CP_\d+_NAME$/i.test(k))
    .sort((a, b) => {
      const nA = parseInt(a.match(/^CP_(\d+)_NAME$/i)![1], 10);
      const nB = parseInt(b.match(/^CP_(\d+)_NAME$/i)![1], 10);
      return nA - nB;
    })
    .filter(nameKey => {
      const p   = nameKey.replace(/_NAME$/i, '');
      const tod = (record as any)[`${p}_TOD`]  ?? '-';
      const time = (record as any)[`${p}_TIME`] ?? '-';
      return tod !== '-' && time !== '-';
    });

  cpNameKeys.forEach(nameKey => {
    const p   = nameKey.replace(/_NAME$/i, '');
    const div = (record as any)[nameKey]        ?? '';
    const tod = (record as any)[`${p}_TOD`]     ?? '';
    const time = (record as any)[`${p}_TIME`]    ?? '';
    rows.push({ key: nameKey, div, tod, time });
  });

  /* === 4. 렌더링 === */
  const baseTop = 66;
  const gap = 3.05;

  return rows.map((row, idx) => {
    const top = baseTop + idx * gap;
    return (
      <React.Fragment key={row.key}>
        <div style={{
          color:'#FFF102', position:'absolute',
          top:`${top}%`, left:'24%', transform:'translate(-50%, -50%)',
          fontSize:'20px', fontWeight:'bold', whiteSpace:'nowrap'
        }}>
          {row.div}
        </div>

        <div style={{
          color:'#FFF102', position:'absolute',
          top:`${top}%`, left:'50%', transform:'translate(-50%, -50%)',
          fontSize:'20px', fontWeight:'bold', whiteSpace:'nowrap'
        }}>
          {row.tod}
        </div>

        <div style={{
          color:'#FFF102', position:'absolute',
          top:`${top}%`, left:'77%', transform:'translate(-50%, -50%)',
          fontSize:'20px', fontWeight:'bold', whiteSpace:'nowrap'
        }}>
          {row.time}
        </div>
      </React.Fragment>
    );
  });
};

  // 기존 고정 스타일 객체
  const styles: Record<string, React.CSSProperties> = {
    compTitle: {
      color: '#02A0E7',
      top: '6%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      position: 'absolute',
      fontSize: '35px',
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
    },
    compDivLs: {
      color: '#FFF102',
      top: '20%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      position: 'absolute',
      fontSize: '35px',
      fontWeight: 'bold',
    },
    compBib: {
      color: '#FFF102',
      top: '25%',
      left: '35%',
      transform: 'translate(-50%, -50%)',
      position: 'absolute',
      fontSize: '35px',
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
    },
    compGender: {
      color: '#FFF102',
      top: '25%',
      left: '65%',
      transform: 'translate(-50%, -50%)',
      position: 'absolute',
      fontSize: '35px',
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
    },
    userName: {
      color: '#FFF102',
      top: '30%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      position: 'absolute',
      fontSize: '45px',
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
    },
    compRecord: {
      color: '#EA5505',
      top: '36%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      position: 'absolute',
      fontSize: '50px',
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
    },
    startTime: { color: '#FFF102', top: '42%', left: '38%', transform: 'translate(-50%, -50%)', position: 'absolute', fontSize: '20px', fontWeight: 'bold', whiteSpace: 'nowrap' },
    arriveTime: { color: '#FFF102', top: '42%', left: '78%', transform: 'translate(-50%, -50%)', position: 'absolute', fontSize: '20px', fontWeight: 'bold', whiteSpace: 'nowrap' },
    pace: { color: '#FFF102', top: '46%', left: '38%', transform: 'translate(-50%, -50%)', position: 'absolute', fontSize: '20px', fontWeight: 'bold', whiteSpace: 'nowrap' },
    speed: { color: '#FFF102', top: '46%', left: '78%', transform: 'translate(-50%, -50%)', position: 'absolute', fontSize: '20px', fontWeight: 'bold', whiteSpace: 'nowrap' },
    totalRank: { color: '#FFF102', top: '54%', left: '19.5%', transform: 'translate(-50%, -50%)', position: 'absolute', fontSize: '18px', fontWeight: 'bold', whiteSpace: 'nowrap' },
    genderRank: { color: '#FFF102', top: '54%', left: '40%', transform: 'translate(-50%, -50%)', position: 'absolute', fontSize: '18px', fontWeight: 'bold', whiteSpace: 'nowrap' },
    teamRank: { color: '#FFF102', top: '54%', left: '60%', transform: 'translate(-50%, -50%)', position: 'absolute', fontSize: '18px', fontWeight: 'bold', whiteSpace: 'nowrap' },
    runType: { color: '#FFF102', top: '54%', left: '80%', transform: 'translate(-50%, -50%)', position: 'absolute', fontSize: '20px', fontWeight: 'bold', whiteSpace: 'nowrap' },
  };

  // 모바일 대응: 원본 캔버스(예: 600x800) 디자인을 감싸는 부모 컨테이너에 transform: scale() 적용
  // recordprint 이미지의 자연 크기에 따라 캔버스 크기를 설정
  const [canvasWidth, setCanvasWidth] = useState(600);
  const [canvasHeight, setCanvasHeight] = useState(800);

  useEffect(() => {
    const img = new Image();
    img.src = recordprint;
    img.onload = () => {
      if (img.naturalWidth > img.naturalHeight) {
        setCanvasWidth(842);
        setCanvasHeight(595);
      } else {
        setCanvasWidth(595);
        setCanvasHeight(842);
      }
    };
  }, []);
  
  const [scale, setScale] = useState(1);
  useEffect(() => {
    const handleResize = () => {
      if (canvasWidth) {
        const availableWidth = window.innerWidth - 20; // 여백 고려
        const newScale = Math.min(1, availableWidth / canvasWidth);
        setScale(newScale);
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, [canvasWidth]);
  
  const navigatePrint = () => {
    navigate(`/recordprint/${compTitle}/${bibNum}`, {
      state: {
        userName,
        compTitle: compTitleState,
        compDivLs,
        compRecord,
        compBib: userBib,
        compCode: locationState.compCode,
        sex : gender,
      }
    });
  };

  const navigateMobilePrint = () => {
    navigate(`/recordmobileprint/${compTitle}/${bibNum}`, {
      state: {
        userName,
        compTitle: compTitleState,
        compDivLs,
        compRecord,
        compBib: userBib,
        compCode: locationState.compCode,
        sex : gender,
      }
    });
  };

  const goToQrcodePage = () => {
    navigate('/qrcode', {
      state: {
        name: userName,
        bibNumber: userBib,
        competitionName: compTitleState,
        personalRecord: compRecord,
        division: compDivLs
      }
    });
  };

  const handlePhotoRecord = () => {
    navigate(`/recordphotoprint/${compTitle}/${bibNum}`, {
      state: {
        userName,
        compTitle: compTitleState,
        compDivLs,
        compRecord,
        compBib: userBib,
        compCode: locationState.compCode,
        startRecord,
        arrivalRecord,
        sex : gender,
      }
    });
  };

  return (
    <div className="flex flex-col items-center">
      {/* 디버그용 */}
      <div style={{ position: 'absolute', top: 0, right: 0, color: 'red', fontSize: '16px' }}>
        compCode: {compCode}
      </div>
      {/* 반응형 스케일링 적용 */}
      <div className="mt-8 mb-8 mx-auto" style={{ width: canvasWidth * scale, height: canvasHeight * scale }}>
        <div
          style={{
            transform: `scale(${scale})`,
            transformOrigin: 'top left',
            width: canvasWidth,
            height: canvasHeight,
          }}
        >
          <div id="canvas-container" style={{ position: 'relative', width: `${canvasWidth}px`, height: `${canvasHeight}px`, overflow: 'hidden' }}>
            <img src={recordprint} alt="background" style={{ width: '100%', height: 'auto', objectFit: 'cover', position: 'absolute', left: 0, top: 0 }} />
            <div style={styles.compTitle}>{compTitleState}</div>
            <div style={styles.userName}>{userName}</div>
            <div style={styles.compDivLs}>{compDivLs}</div>
            <div style={styles.compBib}>{bibNum}</div>
            <div style={styles.compGender}>{gender}</div>
            <div style={styles.compRecord}>{compRecord}</div>
            <div style={styles.startTime}>{startRecord}</div>
            <div style={styles.arriveTime}>{arrivalRecord}</div>
            <div style={styles.pace}>{Pace}</div>
            <div style={styles.speed}>{Speed}</div>
            <div style={styles.totalRank}>{totalRank}</div>
            <div style={styles.genderRank}>{genderRank}</div>
            <div style={styles.teamRank}>{teamRank}</div>
            <div style={styles.runType}>{runType}</div>
            {record && renderCPRows()}
          </div>
        </div>
      </div>

      {/* 버튼 영역 - w-full로 전체 너비를 확보하여 모바일에서도 가운데 정렬 */}
      <div className="w-full flex justify-center gap-4 mb-8">
        <Button size="lg" onClick={navigateMobilePrint} color="blue" className="text-xl">
          모바일 기록증
        </Button>
        <Button size="lg" onClick={navigatePrint} color="blue" className="text-xl">
          일반기록증
        </Button>
        <Button size="lg" onClick={handlePhotoRecord} color="blue" className="text-xl">
          사진기록증
        </Button>
      </div>

      {compDivLs.toLowerCase() !== "5km" && (
        <div className="w-full flex justify-center mt-1 mb-20">
          <Button size="lg" onClick={goToQrcodePage} color="deep-orange" className="text-xl">
            메달각인, 포토월 이용 QR코드 생성
          </Button>
        </div>
      )}
    </div>
  );
};

export default RecordInfo;
